
/**
 * Several constants exported for reference in different contexts.
 */
module.exports = Object.freeze({
    // Indexes in lifecycle array.
    NAME:      0,
    DATE:      1,

    // Phase names with special associated functionality.
    PRELAUNCH: 'pre-launch',
    LAUNCHED:  'launched',
    LIVE:      'live',
    EXPIRED:   'expired',
    ANY:       ':any',

    // `getPhaseStart` formats.
    UNIXTIME:  'unixtime',
    MOMENT:    'moment',

    LOADTEST_LAUNCHED: '2010-01-01 00:00:00',
    LOADTEST_EXPIRED: '2038-01-01 00:00:00',
});
